"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IContext_1 = require("./IContext");
/**
 * 单例 主要存储上下文和鉴权信息 由外部注入
 */
var Context = /** @class */ (function () {
    function Context() {
    }
    Context.getInstance = function () {
        if (!Context.instance) {
            
            Context.instance = new this();
        }
        return Context.instance;
    };
    // 初始化上下文
    Context.prototype.setContext = function (context) {
        console.log("-------------------------------context:" + JSON.stringify(context));
        this.context = context;
    };
    Object.defineProperty(Context.prototype, "wtk", {
        get: function () {
            return Context.instance.context.profile.wtk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "tk", {
        get: function () {
            return Context.instance.context.profile.tk || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "settings", {
        get: function () {
            return Context.instance.context.settings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "appId", {
        get: function () {
            return Context.instance.context.appId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "language", {
        get: function () {
            return Context.instance.context.language === "en" ? "en" : "zh-cn";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "platForm", {
        get: function () {
            return Context.instance.context.platForm || IContext_1.IPlatForm.H5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "bizType", {
        get: function () {
            return Context.instance.context.bizType || IContext_1.IBizType.INNER_USER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "accessChannel", {
        get: function () {
            if ([
                IContext_1.IBizType.INNER_USER,
                IContext_1.IBizType.PRIVATE_USER,
                IContext_1.IBizType.OUTTER_USER,
            ].includes(this.bizType)) {
                return IContext_1.IAccessChannel.USER;
            }
            return IContext_1.IAccessChannel.DOCTOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "uid", {
        get: function () {
            return Context.instance.context.uid;
        },
        set: function (value) {
            Context.instance.context.uid = value;
        },
        enumerable: false,
        configurable: true
    });
    Context.instance = null;
    return Context;
}());
exports.default = Context;
//# sourceMappingURL=Context.js.map